import React, { useEffect } from "react";

interface FontDescriptor {
  family: string;
  url: string;
  weights: string[];
}

const fontDefinitions: FontDescriptor[] = [
  {
    family: "Poppins",
    url: "https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700&display=swap",
    weights: ["400", "500", "600", "700"],
  },
  {
    family: "Open Sans",
    url: "https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;500;600;700&display=swap",
    weights: ["400", "500", "600", "700"],
  },
];

export const ThemeFonts: React.FC = () => {
  useEffect(() => {
    // Load fonts if they're not already loaded
    fontDefinitions.forEach((font) => {
      const linkId = `font-${font.family.replace(/\s+/g, "-")}`;
      if (!document.getElementById(linkId)) {
        const link = document.createElement("link");
        link.id = linkId;
        link.rel = "stylesheet";
        link.href = font.url;
        document.head.appendChild(link);
      }
    });
  }, []);

  return (
    <style
      dangerouslySetInnerHTML={{
        __html: `
        :root {
          --font-primary: "Poppins", -apple-system, BlinkMacSystemFont, "Segoe UI",
            Roboto, sans-serif;
          --font-secondary: "Open Sans", -apple-system, BlinkMacSystemFont,
            "Segoe UI", Roboto, sans-serif;
        }

        /* Font classes for direct use */
        .font-primary {
          font-family: var(--font-primary) !important;
        }

        .font-secondary {
          font-family: var(--font-secondary) !important;
        }

        .font-weight-400 {
          font-weight: 400 !important;
        }

        .font-weight-500 {
          font-weight: 500 !important;
        }

        .font-weight-600 {
          font-weight: 600 !important;
        }

        .font-weight-700 {
          font-weight: 700 !important;
        }
      `,
      }}
    />
  );
};
